var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"mt-2",attrs:{"label":_vm.obj.schema.label,"outlined":!_vm.obj.schema.disabled,"dense":true,"rules":_vm.obj.schema.rules,"disabled":_vm.obj.schema.disabled},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }